import {
  ShowContextProvider,
  Title,
  useEditController,
  ReferenceField,
  FunctionField,
} from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { colors, fontFamilyMono } from "../../data/tokens";
import { ParticipatedChip } from "./user-elections-util";

const labelSx = {
  fontSize: 11,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: colors.textMuted,
};

// Ficha no padrão do painel: eleição em destaque com o badge de
// participação, membro com link para o cadastro e identificador
// técnico copiável — a versão antiga listava os campos crus empilhados.
export const UserElectionShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "user-elections/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Eleições" />
      <PageTopBreadcrumb
        title="Eleições"
        firstPath="/#/user-elections/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: colors.primaryDark,
                }}
              >
                {record.name}
              </Typography>
              <ParticipatedChip participated={record.participated} />
            </Box>

            <Divider sx={{ marginY: 2.5 }} />

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 4,
                alignItems: "flex-start",
              }}
            >
              <Box>
                <Typography sx={labelSx}>Ano</Typography>
                <Typography
                  sx={{
                    fontSize: 13.5,
                    color: colors.textStrong,
                    fontFamily: fontFamilyMono,
                  }}
                >
                  {record.year ?? "—"}
                </Typography>
              </Box>
              <Box>
                <Typography sx={labelSx}>Membro</Typography>
                <ReferenceField
                  source="userId"
                  reference="users/crud"
                  link="show"
                >
                  <FunctionField
                    render={(member: any) => (
                      <Typography
                        component="span"
                        sx={{
                          fontSize: 13.5,
                          fontWeight: 600,
                          color: colors.primaryDark,
                        }}
                      >
                        {member?.fullName}
                      </Typography>
                    )}
                  />
                </ReferenceField>
              </Box>
              <Box>
                <Typography sx={labelSx}>Identificador técnico</Typography>
                <Box sx={{ marginTop: 0.5 }}>
                  <IdChip value={record.id} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
